import { setupSideNavConfig } from './setupSideNavConfig';
import {
  getLabelSetupRoute,
  getOpsDashboardBaseRoute,
} from '@src/routing/utils';
import { topLevelRoutes } from '../routes';

/*
  Cannot add component to this config, because if a component needs to use this for linking,
  we will have cyclic dependencies.
  So, created another file for route component mapping (./routeComponent.ts)

  o route - route in react app
  o oldRoute - route in angular app
  o isTopLevel - if the route is top level route of manage (navigation from manage side nav)
*/
export const setupRoutes = {
  apiKeyManagementConsole: {
    route: '/apiKeyManagementConsole',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_api_key_management,
  },
  hubSetup: {
    route: '/hubs',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_hubs,
  },
  miscHubOpsAttendance: {
    route: '/miscHubOps/attendance',
    isTopLevel: true,
  },
  setupEmployees: {
    route: '/employees',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_employees,
  },
  appUsers: {
    route: '/appUsers',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.app_user?.setup?.read,
  },
  appUserCategories: {
    route: '/appUsers/categories',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.app_user?.categories?.read,
  },
  appUserDevices: {
    route: '/appUsers/devices',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.app_user?.imei?.read,
  },
  appUserApproval: {
    route: '/appUsers/approval',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.app_user?.enableWorkerCreationApproval,
  },
  vehicleApproval: {
    route: '/transport/vehicleApproval',
    isAllowed: masterData => masterData?.enable_vehicle_approval,
  },
  customerAllocationRules: {
    route: '/customerRules',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.setup_client_allocation_rules,
  },
  myDTDCConfig: {
    route: '/setupMyDTDCBanner',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.show_mydtdc_banners,
  },
  customerManagement: {
    route: '/customerManagement',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_client_management,
  },
  customerDetails: {
    route: '/customerManagement/customerDetails/:id',
    isTopLevel: true,
    isAllowed: (masterData) =>
      masterData?.location_master_config?.setup_client_management,
  },
  customerManage: {
    route: '/customerManagement/customerManage',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_client_management,
  },
  customerCommunicationPreferenceManage: {
    route: '/customerManagement/customerCommunicationPreferenceManage',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_client_management,
  },
  inventoryRequests: {
    route: '/customerManagement/inventoryRequests',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_client_management,
  },
  globalSeries: {
    route: '/customerManagement/globalSeries',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_global_virtual_series,
  },
  customerConfiguration: {
    route: '/customerManagement/customerConfiguration',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_customer_portal_config,
  },
  customerProfile: {
    route: '/customerManagement/customerProfile',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.enable_customer_config,
  },
  customerAddresses: {
    route: '/customerManagement/customerAddresses',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_client_management,
  },
  appFlowConfig: {
    route: '/appFlowConfig',
    isTopLevel: true,
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_appflow_config,
  },
  master:{
    route: '/appFlowConfig/master',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_delivery_config,
  },
  serviceTaskMapping: {
    route: '/appFlowConfig/serviceTaskMapping',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.show_service_task_mapping,
  },
  twoFactorAuth: {
    route: '/appFlowConfig/twoFactorAuth',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.show_two_factor_auth_screen,
  },
  rescheduledReasons: {
    route: '/appFlowConfig/rescheduledReasons',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_reschedule_reason,
  },
  serviceType: {
    route: '/appFlowConfig/serviceType',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_service_type,
  },
  merchantDetails: {
    route: '/appFlowConfig/merchantDetails',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_merchant_details,
  },
  configObject: {
    route: '/appFlowConfig/configObject',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_appflow_config,
  },
  organisationSettings: {
    route: '/appFlowConfig/organisationSettings',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.enable_app_settings,
  },
  receiversRelation: {
    route: '/appFlowConfig/receiversRelation',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_receiver_relation,
  },
  undeliveredReasons: {
    route: '/appFlowConfig/undeliveredReasons',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_reason_master,
  },
  kyc: {
    route: '/appFlowConfig/kyc',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_kyc,
  },
  packagingTypeMaster: {
    route: '/appFlowConfig/packagingTypeMaster',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.show_ltl_packaging_type_master,
  },
  partialDeliveryReasons: {
    route: '/appFlowConfig/partialDeliveryReasons',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show
        ?.show_ltl_partial_delivery_reason,
  },
  lateDeliveryReasons: {
    route: '/appFlowConfig/lateDeliveryReasons',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show
        ?.show_ltl_late_delivery_reason,
  },
  bookingMasters: {
    route: '/bookingMasters/masterData',
    isTopLevel: true,
    isAllowed: masterData => (
      masterData.ops_dashboard_config.parts_to_show.setup_booking_master ||
      masterData.ops_dashboard_config.parts_to_show.setup_booking_master_edit),
  },
  admVehicles: {
    route: '/admVehicles',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_adm_vehicles,
  },
  headerMapping: {
    route: '/headerMapping',
    isTopLevel: true,
    isAllowed: masterData => 
      masterData.ops_dashboard_config.parts_to_show.setup_header_mapping || 
      masterData.ops_dashboard_config.parts_to_show.setup_ops_dashboard_header_mapping,
  },
  headerMappingOpsDashboard: {
    route: '/headerMapping/opsDashboard',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_ops_dashboard_header_mapping,
  },
  headerMappingCustomerPortal: {
    route: '/headerMapping/customerPortal',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_header_mapping,
  },
  thirdParty: {
    route: '/thirdParty',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_third_party_vendor,
  },
  rateMasters: {
    route: '/rateMasters',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_rate_master,
  },
  carrierPartner: {
    route: '/carrierPartner',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_carrier_partner ||
      masterData.setup_to_show_in_opsv2?.carrier_partner,
  },
  carrierAccountIntegration: {
    route: '/carrierPartner/carrierAccountIntegration',
    isTopLevel: false,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show
      ?.show_carrier_partner_revamp,
  },
  carrierPartnerCarriers: {
    route: '/carrierPartner/carrier',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.carrier_master?.setup?.read,
  },
  courierFieldMaster:{
    route: '/carrierPartner/courierFieldMaster',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.carrier_master?.courier_field_master?.read,
  },
  carrierAllocation:{
    route: '/carrierPartner/carrierAllocation',
    isAllowed: masterData => true,
  },
  courierTracking:{
    route: '/carrierPartner/courierTracking',
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_courier_tracking_integration_parts || true,
  },
  advancedSettings:{
    route: '/carrierPartner/advancedSettings',
    isAllowed: masterData => masterData.show_carrier_advanced_settings,
  },
  carrierAllocationDownloads: {
    route: '/carrierPartner/carrierAllocationDownloads',
    isAllowed: masterData =>
    masterData.ops_dashboard_config.config.async_courier_account_allocation_rules_download,
  },
  carrierChangeReasonMaster: {
    route: '/carrierPartner/carrierChangeReasonMaster',
    isAllowed: masterData =>
      masterData?.courier_partner_config?.show_courier_partner_change_reason,
  },
  transport: {
    route: '/transport',
    isTopLevel: true,
    isAllowed: masterData => (masterData.ops_dashboard_config.parts_to_show.setup_transport_module
               || masterData.ops_dashboard_config.parts_to_show.setup_vehicle_module),
  },
  transportVendor: {
    route: '/transport/vendor',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.vendor?.read,
  },
  transportVehicleMake: {
    route: '/transport/vehicleMake',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.vehicle_make?.read,
  },
  transportVehicleCategory: {
    route: '/transport/vehicleCategory',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.vehicle_category?.read,
  },
  transportOptimizerTags: {
    route: '/transport/optimizerTags',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.optimizer_tag?.read,
  },
  transportVehicleDocuments: {
    route: '/transport/vehicleDocuments',
    isAllowed: masterData =>
    masterData.ops_dashboard_config.parts_to_show.setup_vehicle_documents_module || true,
  },
  transportVehicleCompartment: {
    route: '/transport/vehicleCompartment',
    isAllowed: masterData =>
      masterData?.ops_dashboard_config?.parts_to_show
      ?.setup_vehicle_compartment_master?.read || false,
  },
  transportFlmRoute: {
    route: '/transport/flmRoute',
    isAllowed: masterData =>
      masterData?.ops_dashboard_config?.parts_to_show
      ?.setup_flm_route_master?.read || false,
  },
  transportVehicle: {
    route: '/transport/vehicle',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.vehicle?.read,
  },
  network: {
    route: '/network',
    isTopLevel: true,
    isAllowed: masterData => (
      masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.route?.read ||
    masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.connection?.read ||
    masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.routing?.read ||
    masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.exception?.read ||
    masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.bagging?.read
    ),
  },
  transportRoute: {
    route: '/network/routes',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.route?.read,
  },
  transportRouteDetails: {
    route: '/network/routes/details/:routeId',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_transport_module,
  },
  transportConnection: {
    route: '/network/connections',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.connection?.read,
  },
  transportException: {
    route: '/network/exceptions',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.exception?.read,
  },
  transportRouting: {
    route: '/network/routing',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.routing?.read,
  },
  transportBagging: {
    route: '/network/bagging',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.bagging?.read,
  },
  vehicleRestrictions: {
    route: '/transport/vehicleRestrictions',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show
    ?.vehicle_restriction_config?.isEnabled == true
    && masterData.ops_dashboard_config.parts_to_show.setup_permission_obj?.transport?.vehicle_restriction?.read,
  },
  transportDocks: {
    route: '/hubs/docks',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.dock?.read,
  },
  transportGates: {
    route: '/hubs/gates',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.gate?.read,
  },
  transportEwbThresholdMaster: {
    route: '/transport/ewbThresholdMaster',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.ewb_threshold_master,
  },
  transportMoveableAssets: {
    route: '/transport/moveable-assets',
    isAllowed: masterData =>  masterData?.ops_dashboard_config?.
    parts_to_show?.setup_moveable_asset_master?.read
  },
  shelfManagement: {
    route: '/shelf/management',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.show_shelf_data,
  },
  setupPromocode: {
    route: '/promocode',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.show_promo_campaign,
  },
  addressHierarchy: {
    route: '/addressHierarchy',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_address_config,
  },
  pincode: {
    route: '/pincode/pincodeMasters',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_pincode_master,
  },
  expressBookingMasters: {
    route: '/expressBookingMasters',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_booking_masters_v2,
  },
  supplementaryServices: {
    route: '/supplementaryServices',
    isTopLevel: true,
    isAllowed: masterData => masterData?.ops_dashboard_config?.parts_to_show?.show_setup_supplementary_services || false,
  },
  pricing: {
    route: '/pricing',
  },
  courierPricing: {
    route: '/courierPricing',
  },
  courierTat: {
    route: '/courierTat',
  },
  courierDestinationType: {
    route: '/courierestinationType',
  },
  courierServiceability: {
    route: '/courierServiceability',
  },
  courierHoliday: {
    route: '/courierHoliday',
  },
  tat: {
    route: '/expressBookingMasters/tat',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.booking_master_v2?.tat?.read,
  },
  serviceability: {
    route: '/expressBookingMasters/serviceability',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.booking_master_v2?.serviceability?.read,
  },
  destinationType: {
    route: '/expressBookingMasters/destinationType',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.booking_master_v2?.destination?.read,
  },
  holidayv2: {
    route: '/expressBookingMasters/holidayv2',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
      ?.booking_master_v2?.holidayv2?.read,
  },
  polygonMaster: {
    route: '/expressBookingMasters/polygonMaster',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.booking_master_v2?.polygon_master?.read,
  },
  passwordPolicy: {
    route: '/password-policy',
    isTopLevel: true,
    isAllowed: masterData => masterData.show_password_policy,
  },
  smsManagement : {
    route : '/sms/management',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_sms_integration_parts,
  },
  marketPlaceIntegration : {
    route : '/market-place-integration',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData?.show_external_setup_section || false,
  },
  validationBuilder : {
    route : '/validation/management',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_validation_builder ||
      masterData.ops_dashboard_config.parts_to_show.show_transformation_builder,
  },
  setupValidationBuilder: {
    route : '/validation/management',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_validation_builder,
  },
  transformationBuilder : {
    route : '/validation/management/transformation',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_transformation_builder,
  },
  emailManagement : {
    route : '/sms/management/email/template',
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.use_generic_email_templates,
  },
  pushNotifications: {
    route: '/pushNotifications',
    isTopLevel: true,
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config.parts_to_show.setup_push_notifications,
  },
  configurations : {
    route: '/configurations',
    isTopLevel: true,
    isAllowed: masterData => masterData.show_allocation_setup,
  },
  genericConfigurations : {
    route: '/generic-configurations',
    isTopLevel: true,
    isAllowed: masterData => masterData?.ops_dashboard_config?.parts_to_show?.setup_generic_config || false,
  },
  labelSetup : {
    route : getLabelSetupRoute(),
    isTopLevel: true,
    isAllowed: masterData =>
      masterData.ops_dashboard_config.parts_to_show.show_code_free_label_setup,
  },
  transportConsignmentRoute: {
    route: '/transport/consignmentRoute',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.transport?.consignment_route?.read,
  },
  reasonCategoryMaster: {
    route: '/appFlowConfig/reasonCategoryMaster',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_reason_master,
  },
  resequencingReasonMaster: {
    route: '/appFlowConfig/resequencingReasonMaster',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_reason_master,
  },
  ltlNDRMaster: {
    route: '/appFlowConfig/ltlNDRMaster',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.use_ltl_ndr,
  },
  itemUnitMaster: (masterData) => masterData?.ops_dashboard_config?.
                      parts_to_show?.setup_item_unit_master?.read,
  vehicleCompartmentMaster: (masterData) => masterData?.ops_dashboard_config?.
  parts_to_show?.setup_vehicle_compartment_master?.read,
  seriesConsumptionRules: {
    route: '/seriesConsumption',
    isTopLevel: true,
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show
    && masterData.ops_dashboard_config.parts_to_show.show_series_consumption_rules_module,
  },
  rosterManagement: {
    route: '/roster-management',
    isTopLevel: true,
    isAllowed: masterData => (masterData.show_roster_management_ondemand && masterData?.allow_roster_read) || masterData.use_rider_roster_v2,
  },
  customerRosterManagement: {
    route: '/customerManagement/customer-roster-management',
    isAllowed: masterData => masterData.show_customer_schedule_master,
  },
  riderManagement: {
    route: '/rider-management',
    isTopLevel: true,
    isAllowed: masterData =>  masterData?.ops_dashboard_config?.parts_to_show?.food_dashboard_rider_management_read || false,
  },
  riderReferralProgram: {
    route: '/referral-program',
    isTopLevel: true,
    isAllowed: masterData => masterData?.show_referral_tab || false,
  },
  riderPayout: {
    route: '/payout',
    isTopLevel: true,
    isAllowed: masterData => masterData.rider_payout_read || false,
  },
  contracts: {
    route: '/rateMasters/contracts',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.rate_masters?.contracts?.read,
  },
  invoice: {
    route: '/rateMasters/invoice',
    isAllowed: masterData => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
    ?.rate_masters?.invoice?.read,
  },
  courierContracts: {
    route: '/rateMasters/courierContracts',
    isAllowed: (masterData) => masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
      ?.rate_masters?.courierwise_contracts?.read,
  },
  tripContracts: {
    route: '/rateMasters/tripContracts',
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
      ?.rate_masters?.trip_contracts?.read,
  },
  currencyConversion: {
    route: '/currencyConversion',
    isTopLevel: true,
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config.parts_to_show.setup_permission_obj
      ?.currency?.conversion?.read,
  },
  addressRegisterDetails: {
    route: '/addressRegister/:id',
    isTopLevel: true,
    isAllowed: masterData => true,
  },
  addressRegister: {
    route: '/addressRegister',
    isTopLevel: true,
    isAllowed: (masterData) =>
      (masterData?.location_master_config?.show_in_setup && masterData?.ops_dashboard_config?.parts_to_show?.setup_address_register) || false,
  },
  consignmentRouteDownloads: {
    route: '/transport/consignmentRoute/consignmentRouteDownloads',
    isTopLevel: false,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.transport?.download?.read || false,
  },
  pricingPlayground: {
    route: '/rateMasters/pricingPlayground',
    isAllowed: (masterData) => masterData.allocation_engine_playground_update,
  },
  hubOpsConfig: {
    route: '/appFlowConfig/hubOpsConfig',
    isTopLevel: false,
    isAllowed: (masterData) =>
      masterData.ops_dashboard_config?.parts_to_show?.setup_hubops_config,
  },
  objectBuilder: {
    route: '/objectBuilder',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.setup_object_builder,
  },
  viewBuilder: {
    route: '/viewBuilder',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.setup_view_builder,
  },
  pageBuilder: {
    route: '/pageBuilder',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.setup_page_builder,
  },
  workflowBuilder: {
    route: '/workflowBuilder',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.setup_workflow_builder,
  },
  hubCategory: {
    route: '/hubs/hubCategory',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_permission_obj
    ?.hub?.hub_category?.read,
  },
  hubInventoryRequests: {
    route: '/hubs/inventoryRequests',
    isAllowed: masterData => masterData.ops_dashboard_config?.parts_to_show?.setup_hub_virtual_series,
  },
  downloadRequestsMiddleMile: {
    route: '/downloadRequests',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.ops_dashboard_config?.parts_to_show?.gme_master_download_async,
  },
  ticketManagement: {
    route: '/ticket-management',
    isTopLevel: true,
    isAllowed: (masterData) => masterData.show_ticketing_tool_master_setup,
  },
  globalConfigVersioning: {
    route: '/config-versions',
    isTopLevel: true,
    isAllowed: () => true,
  },
};

export const getSetupBaseRoute =
  () => `${getOpsDashboardBaseRoute()}${topLevelRoutes.setup.route}`;

export const getFullRouteForId = (routeId) => {
  const routeObj = setupRoutes[routeId];
  return `${getSetupBaseRoute()}${routeObj.route}`;
};

export const getDefaultRouteIdTransport = (masterData) => {
  const routeObj = setupRoutes['transportVehicle'];
  if(routeObj.isAllowed(masterData))
  {
    return getFullRouteForId('transportVehicle');
  }
  return getFullRouteForId('transportVendor');
};

export const shouldAllowSetupRoute = (masterData, routeId) => {
  const routeObj = setupRoutes[routeId];
  if (!routeObj || !routeObj.isAllowed) {
    return true;
  }
  return routeObj.isAllowed(masterData) || false;
};

const topLevelPriorityList = setupSideNavConfig.map(elem => elem.routeId);
export const defaultTopLevelSetup = (masterData) => {
  return topLevelPriorityList.find(id => shouldAllowSetupRoute(masterData, id));
};
